export { default } from 'modules/Customers/Customers'
export { ArchiveCustomerModal } from './components/modals/archiveCustomer/ArchiveCustomerModal'
export {
  ArchiveCustomerMenuItem,
  LinkCustomerMenuItem,
  UnlinkCustomerMenuItem,
  ViewCustomerDetailsMenuItem
} from './components/menuItems'
export { useConnectedIntegrationCustomers } from './utils/useConnectedIntegrationCustomers'
export type { Customer } from './types'
